import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import { configArea } from '@/config/system'
import { getAppraiseLabels } from '@/api/hallApi'
import { getUserInfo } from '@/api/oAuth'
import { INVOKESERVICE_CODE, INVOKECALLER_CODE } from '@/api/config'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 搜索类别
    searchType: null,
    // 搜索关键字
    searchValue: null,
    // 当前区域
    currentArea: configArea[0],
    // 当前城市
    currentCity: configArea[0].name,
    // 当前获取的定位
    trip: {
      startLngLat: [],
      endLngLat: []
    },
    mapObject: null,
    geoLocation: [],
    hallList: [],
    prohallList: [],
    hallListSearch: [],
    driving: null,  // 驾车
    transfer: null, // 公交
    walking: null,  // 走路
    isFitView: false, // 适应屏幕标志位，定位完成后为true
    isHideMarkerInfo: false, // 地图缩放级别大时，隐藏label
    tagsNames: [],
    userInfo: {},
    zxblStatus:'',
    proSort:'distance',
    itemCodeMap:'',
    cityOfficeCode:''
  },
  mutations: {
    setZxblStatus(state, val) {
      state.zxblStatus = val
    },
    setProSort(state, val) {
      state.proSort = val
    },
    setItemCodeMap(state, val) {
      state.itemCodeMap = val
    },
    setcityOfficeCode(state, val) {
      state.cityOfficeCode = val
    },
    setUserInfo(state, val) {
      state.userInfo = val
    },
    setMapObject(state, val) {
      state.mapObject = val
    },
    setGeoLocation(state, val) {
      state.geoLocation = val
    },
    setHallList(state, val) {
      state.hallList = val
    },
    setproHallList(state, val) {
      state.prohallList = val
    },
    setHallListSearch(state, val) {
      state.hallListSearch = val
    },
    // 驾车路线
    setDriving(state, val) {
      state.driving = val
    },
    // 公交路线
    setTransfer(state, val) {
      state.transfer = val
    },
    // 走路路线
    setWalking(state, val) {
      state.walking = val
    },
    // 适应屏幕标志位，定位完成后为true
    setIsFitView(state, val) {
      state.isFitView = val
    },
    // 地图缩放级别大时，隐藏label
    setIsHideMarkerInfo(state, val) {
      state.isHideMarkerInfo = val
    },
    setTagsNames(state, val) {
      state.tagsNames = val
    },
    setSearchValue (state, props) {
      state.searchType = props.type
      state.searchValue = props.value
    },
    setSubject(state,props){
      state.subtype = props.type
      // state.searchValue = props.value
    },
    setCurrentArea (state, props) {
      state.currentArea = props
    },
    setStartPos (state, props) {
      state.trip.startLngLat[0] = props.lng
      state.trip.startLngLat[1] = props.lat
    },
    setEndPos (state, props) {
      state.trip.endLngLat[0] = props.lng
      state.trip.endLngLat[1] = props.lat
    },
    reserveTrip (state) {
      let arr = []
      arr = state.trip.startLngLat
      state.trip.startLngLat = state.trip.endLngLat
      state.trip.endLngLat = arr
    }
  },
  actions: {
    //获取评价满意度标签列表
    getAppraiseLabels({commit}) {
      let that = this;
      getAppraiseLabels({}).then(res => {
        let {state, info, message} = res.data
        if (state === 1) {
          commit('setTagsNames', info)
        }
      }).catch(err =>  {
      })
    },
    getUserInfo({commit}, trustTicket){
      getUserInfo({
        INVOKESERVICE_CODE,
        INVOKECALLER_CODE,
        TRUST_TICKET: trustTicket,
      })
      .then((res) => {
      //   {
      //     "msg": null,
      //     "data": {
      //         "ENTSTORE_IDS": null,
      //         "ASSOCIATIONCONTENT": null,
      //         "LEGALPERSON_ELECURL": "http://61.154.11.191:8083/Licencepdf/pdf/PdfShow?data=%7B%22message_content%22%3A%7B%22uniscid%22%3A%22F24356334%22%2C%22entname%22%3A%22%E6%B5%AA%E6%BD%AE%E6%B5%8B%E8%AF%95%22%2C%22opertime%22%3A%2220220913161814%22%7D%2C%22message_header%22%3A%7B%22syscode%22%3A%22SAIC_YWXT_350001%22%2C%22authcode%22%3A%226191a34c3188484bbfc730822961171b%22%2C%22sign%22%3A%22%22%2C%22version%22%3A%221%22%2C%22businesstype%22%3A%22013%22%7D%7D",
      //         "LEGALPERSON_TYPE": "C01",
      //         "IS_BINDYB": null,
      //         "USER_EMAIL": null,
      //         "WX_PROSIGN": null,
      //         "USER_MOBILE": "18663602986",
      //         "LEGALPERSON_PHONE": "",
      //         "USER_ID": "4028b8816955c0ce016955c1cc0108b2",
      //         "USER_VISAVIEW": -1,
      //         "REMARKS": null,
      //         "USER_PASS": "inym/mGcS0ZpNx4VcN4g+Q==",
      //         "CERT_KEY": "XT5epYRHx/F1fs10lkeBbO4FzNihpq+NmKqkNMjxBI8=",
      //         "REGMONEY": null,
      //         "IS_UPDATEXM": null,
      //         "LEGALPERSON_JDCODE": null,
      //         "USER_AUTHLEVEL": "0",
      //         "LEGALPERSON_ORGTYPE": null,
      //         "USER_CONFIGPASS": "-1",
      //         "GPS_SFBM": null,
      //         "CANCEL_TIME": null,
      //         "IS_APPSIGN": null,
      //         "LEGALPERSON_ZZJGDM": "F24356334",
      //         "FUNDKIND": null,
      //         "USER_HIGHCHANNEL": null,
      //         "CERTS_VALIDDATE": null,
      //         "LEGALPERSON_ZGRS": null,
      //         "REGADDRESS": null,
      //         "GPS_QXBM": null,
      //         "POPULATION_JZDZ": null,
      //         "GPS_CSBM": null,
      //         "LEGALPERSON_ZCZB": null,
      //         "POPULATION_NATION": null,
      //         "USER_GJJLX": null,
      //         "USER_TYPE": 2,
      //         "LEGALPERSON_QYXZ": null,
      //         "POPULATION_AREACODE": null,
      //         "YWTYDM": null,
      //         "REGORGANIZER": null,
      //         "POPULATION_CCITYCODE": null,
      //         "LEGALPERSON_NCCODE": null,
      //         "LEGALPERSON_IDCARD": "370703198609270332",
      //         "WDMLX": null,
      //         "IS_SM4ENCRY": "1",
      //         "USER_JUNTIME": "2019-03-07 09:25:57",
      //         "CERTS_EFFECTDATE": null,
      //         "CARD_TYPE": "111",
      //         "USER_APPEID": null,
      //         "LEGALPERSON_NAME": "张琦",
      //         "LEGALPERSON_JBRNAME": "张琦",
      //         "DMZJ_PATH": null,
      //         "CORP_KEY": "2115a9b63cc9b7e48fd6874add37ae6700f49bd2a9cb8de3a197c0177b2c917b",
      //         "USER_CITYCODE": "350100",
      //         "LEGALPERSON_FRSJH": "18663602986",
      //         "APPSTORE_TYPE": null,
      //         "USER_JUNIORCHANNEL": null,
      //         "YYZZ_PATH": null,
      //         "SFZPCS": null,
      //         "POPULATION_HJDZ": null,
      //         "CZD_AREACODE": null,
      //         "USER_NAME": "浪潮测试",
      //         "XZQH_CODE": null,
      //         "SWB_PASS": "96e79218965eb72c92a549dd5a330112",
      //         "COMPETENTORG": null,
      //         "POPULATION_CADDRESS": null,
      //         "LEGALPERSON_HYMC": null,
      //         "POPULATION_PROCODE": null,
      //         "USER_REMINDTIME": null,
      //         "LEGALPERSON_EMAIL": null,
      //         "ACTAREA": null,
      //         "POPULATION_SEX": null,
      //         "SMALL_PROSIGN": null,
      //         "USER_ROLE": null,
      //         "APPLE_USERID": null,
      //         "USER_CALLERNAME": null,
      //         "LAST_MOBILE": null,
      //         "LEGALPERSON_ZADDRESS": null,
      //         "ENTERPRISECAPITAL": "100",
      //         "USER_ERRORCOUNT": 4,
      //         "LEGALPERSON_XKZ": "fffffffffffff",
      //         "USER_TOKEN": "2b267a314f2048880aace556d8efdb012c9bfdba83334a44018335b9e8fc0c86",
      //         "USER_HITIME": null,
      //         "POPULATION_CPROCODE": null,
      //         "POPULATION_EDU": null,
      //         "IS_HWEID_LOGIN": null,
      //         "ALIPAY_CHECKFACE": null,
      //         "CZD_ADDRESS": null,
      //         "LEGALPERSON_FRXB": null,
      //         "LEGALPERSON_ADDRESS": null,
      //         "USER_UNLOCKTIME": null,
      //         "CZD_CITYCODE": null,
      //         "FUNDSOURCE": null,
      //         "LEGALPERSON_AREACODE": null,
      //         "LEGALPERSON_JJLX": null,
      //         "POPULATION_CAREACODE": null,
      //         "LEGALPERSON_DYLEVEL": null,
      //         "NATION_CODE": null,
      //         "LEGALPERSON_ACCTYPE": "2001",
      //         "REGIST_NUM": null,
      //         "USER_ACCOUNT": "浪潮测试",
      //         "LEGALPERSON_JBRSJH": "18663602986",
      //         "LEGALPERSON_PROCODE": null,
      //         "ENTERPRISEADDRESS": "福建省福州市",
      //         "LEGALPERSON_ZCITYCODE": null,
      //         "POPULATION_WX": null,
      //         "POPULATION_CITYCODE": null,
      //         "HUAWEI_EIDCODE": null,
      //         "LEGALPERSON_ZIPCODE": null,
      //         "REGDATE": "20210411",
      //         "CERT_YXQS": "20120403",
      //         "GESTURE_PASS": "ac45088df2e8d3cd2d8fbafceb920878",
      //         "USER_PHOTOURL": "https://mztapp.fujian.gov.cn:8192/mztAppFile/uploadfile/image/2/20200518/aec3ab6cbc764f60ba56e993348959ee.png",
      //         "SOCIALORGTYPE": null,
      //         "LEGALPERSON_ZAREACODE": null,
      //         "ENTERPRISERANGE": null,
      //         "USER_IDCARD": "F24356334",
      //         "LEGALPERSON_JBRIDCARD": "370703198609270332",
      //         "NATION_LEVEL": null,
      //         "POPULATION_BIRTHDAY": null,
      //         "ENTERPRISEBEGINDATE": "20210414",
      //         "LEGALPERSON_CREAETDATE": null,
      //         "LEGALPERSON_XZQH": null,
      //         "USER_ISTEST": -1,
      //         "IS_UPDATESP": "-1",
      //         "IS_ST": null,
      //         "LEGALPERSON_NJRQ": null,
      //         "BAIDU_PROSIGN": null,
      //         "POPULATION_AGE": null,
      //         "USER_APPREGID": null,
      //         "POPULATION_ALIPAY": null,
      //         "ENTERPRISEAPPROVERAGENCY": "浪潮",
      //         "USER_CREATETIME": "2019-03-07 09:25:57",
      //         "POPULATION_GZDW": null,
      //         "REGRANGE": null,
      //         "VALID_IDCARD": null,
      //         "ENTERPRISEAPPROVALDATE": "20210413",
      //         "USER_THIRDID": "7873DF8147B24D87E109E055F5A100C8",
      //         "USER_PIN": null,
      //         "SWB_ISSM3": "-1",
      //         "LEGALPERSON_CITYCODE": null,
      //         "REGAUTHORITY": null,
      //         "JBR_AUTHLEVEL": "1",
      //         "IS_PERFECT": null,
      //         "INDUSTRY": null,
      //         "QY_TYPE": null,
      //         "USER_SYS": 2,
      //         "ENTERPRISEREGISTERDATE": null,
      //         "LEGALPERSON_ZPROCODE": null,
      //         "AGENTCERTTYPE": "111",
      //         "CHARITYORG": null,
      //         "LOGIN_TYPE": "0",
      //         "SFZ_VALIDYEAR": null,
      //         "USER_CREATEDATE": "2019-03-07",
      //         "LEGALPERSON_NJQX": null,
      //         "LEGAL_KEYID": null,
      //         "LEGALPERSON_JBREMAIL": null,
      //         "LEGALPERSON_GSZCH": null,
      //         "ENTERPRISEENDDATE": "20210413",
      //         "CERT_YXJZ": "20240409"
      //     },
      //     "success": true,
      //     "INVOKELOG_BTIME": "2022-09-13 16:18:14"
      // }
        let {data} = res.data
        if (data) {
          let {
            USER_IDCARD,
            USER_NAME,
            USER_MOBILE
          } = data

          commit('setUserInfo', {
            name: USER_NAME,
            cardNo: USER_IDCARD,
            phone: USER_MOBILE
          })
          console.log('userinfo', USER_IDCARD,
          USER_NAME,
          USER_MOBILE)
        }
        console.log('getUserInfo')
        console.log(res)
      })
      .catch(err => {
        console.log('getUserInfo err')
        console.log(res)
      })
    }
  },
  modules: {
  },
  getters
})
